import * as React from "react";
import { useEffect } from "react";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import {
  StartoverAreYouSureDialog,
  StartoverAreYouSureDialogProps,
} from "../../startOver/startoverAreYouSureDialog";
import { useClinicData } from "../../../clinic/clinicHooks";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface WhatsNextStartOverProps
  extends StartoverAreYouSureDialogProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const WhatsNextStartOver = ({ ...props }: WhatsNextStartOverProps) => {
  const { name: clinicName, clinic: clinicId } = useClinicData();
  useEffect(() => {
    evt({
      category: CATEGORY.PATIENT_RESULT,
      action: ACTION.PATIENT_WHATS_NEXT,
      label: `Clicked start over`,
      props: {
        clinicName,
        clinicId,
      },
    });
  }, [clinicId, clinicName]);

  return <StartoverAreYouSureDialog {...props} />;
};
